<script>
import Timeline from '@/components/timeline/Timeline';
import TimelineEvent from '@/components/timeline/TimelineEvent';
import getErrorMessage from '@/modules/server-errors';

export default {
  name: 'RecentActivityDialog',
  components: {
    Timeline,
    TimelineEvent
  },
  props: {
    site: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      isLoading: false,
      revisions: []
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.revisions = [];
      this.getRevisions();
    },

    close() {
      this.dialogVisible = false;
    },

    getRevisions() {
      this.isLoading = true;
      this.$http
        .get(`/sites/${this.site.id}/revisions`)
        .then(res => (this.revisions = res.data.revisions))
        .catch(err => (this.errorMessage = getErrorMessage(err.response.data.code)))
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<template>
  <el-dialog :title="$t('Recent Activity')" :visible.sync="dialogVisible" class="el-dialog--large">
    <div v-loading="isLoading" class="timeline-container">
      <!-- Timeline -->
      <timeline v-if="revisions.length" :box-shadow="false">
        <timeline-event
          v-for="revision in revisions"
          :key="revision.id"
          :date="$d(new Date(revision.createdAt), 'short')"
        >
          <template slot="title">
            <span class="timeline-avatar">
              <img
                :src="revision.user.avatar ? revision.user.avatar : require('@/assets/user-light.svg')"
                :alt="revision.user.name"
              />
            </span>
            {{ revision.isDraft ? $t('Saved a Draft') : $t('Published Changes') }}
          </template>

          <i18n
            :path="
              revision.isDraft
                ? '{user} saved a draft of {page} on {site}'
                : '{user} published changes to {page} on {site}'
            "
            tag="span"
          >
            <template v-slot:user>
              <router-link :to="{ name: 'User', params: { userId: revision.user.id } }">
                {{ revision.user.name }}
              </router-link>
            </template>
            <template v-slot:site>
              <router-link :to="{ name: 'Site', params: { siteId: revision.site.id } }">
                {{ revision.site.name }}
              </router-link>
            </template>
            <template v-slot:page>
              <router-link :to="{ name: 'EditPage', params: { siteId: revision.site.id, pageId: revision.page.id } }">
                {{ revision.page.name }}
              </router-link>
            </template>
          </i18n>
        </timeline-event>
      </timeline>

      <div v-if="!isLoading && !revisions.length" class="no-activity">
        {{ $t('No Recent Activity') }}
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="close">
        {{ $t('Done') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.timeline-container,
.no-activity {
  min-height: 10rem;
  height: calc(100vh - 20rem);
  overflow: auto;

  @include breakpoint('md-and-down') {
    padding: 0 0 0 0.5rem;
  }
}

.no-activity {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: $--color-gray-40;
  text-align: center;
}

.timeline-avatar {
  img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    vertical-align: middle;
    margin-right: 0.125rem;
  }
}
</style>
